
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral",
      function () {
        return require("private-next-pages/funeral.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral"])
      });
    }
  